import type { ReactNode } from "react";
import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router";

import { EdgeSwipeBackLayer } from "@/components/navigation/EdgeSwipeBackLayer";

type LegalPageLayoutProps = {
  title: string;
  children: ReactNode;
};

export function LegalPageLayout({ title, children }: LegalPageLayoutProps) {
  const navigate = useNavigate();

  return (
    <EdgeSwipeBackLayer className="min-h-[100svh] bg-[oklch(11%_0.02_160)] text-[oklch(88%_0.02_150)]">
      <header className="sticky top-0 z-50 border-b border-[oklch(100%_0_0_/_0.06)] bg-[oklch(11%_0.02_160_/_0.95)] backdrop-blur-md supports-[backdrop-filter]:bg-[oklch(11%_0.02_160_/_0.8)]">
        <div className="mx-auto flex h-14 max-w-3xl items-center gap-2 px-4 pt-[env(safe-area-inset-top)]">
          <button
            type="button"
            className="icon-button shrink-0"
            aria-label="Back"
            onClick={() => navigate(-1)}
          >
            <ArrowLeft size={20} />
          </button>
          <h1 className="text-lg font-semibold tracking-tight">{title}</h1>
        </div>
      </header>

      <main className="mx-auto max-w-3xl px-4 py-8 pb-[max(2rem,env(safe-area-inset-bottom))]">
        <article className="legal-prose">{children}</article>
      </main>
    </EdgeSwipeBackLayer>
  );
}
